// 도감 문턱·점수 (PRD 4.1, 계약 1.2). 값(value)의 뜻: 몬스터·보스 = 처치 수, 세트 = 경험한 부위 수(0..4),
// 펫 = 0(미획득)/레벨(획득 시 ≥ 1), 유니크·아바타 = 0/1. 순수·할당 없음.
import type { CodexCat } from './registry';

export const MONSTER_STEPS = [1, 50, 120, 800] as const; // 점수 1·2·4·8
export const BOSS_STEPS = [1, 10, 40, 150] as const; // 점수 1·2·4·8
export const SET_STEPS = [1, 2, 3, 4] as const; // 부위 수, 점수 1·2·3·2
export const PET_STEPS = [1, 10, 20, 30] as const; // 획득(=1)·Lv, 점수 4·4·4·4
export const UNIQUE_SCORE = 10;
export const AVATAR_SCORE = 2;
export const CODEX_SCORE_MAX = 831;

/** 범주별 단계 문턱 */
export const CODEX_CELL_STEPS: Readonly<Record<CodexCat, readonly number[]>> = {
  monster: MONSTER_STEPS, boss: BOSS_STEPS, set: SET_STEPS, pet: PET_STEPS, unique: [1], avatar: [1],
};
/** 범주별 단계마다 더해지는 점수 */
export const CODEX_STEP_SCORES: Readonly<Record<CodexCat, readonly number[]>> = {
  monster: [1, 2, 4, 8], boss: [1, 2, 4, 8], set: [1, 2, 3, 2], pet: [4, 4, 4, 4], unique: [UNIQUE_SCORE], avatar: [AVATAR_SCORE],
};
/** 범주별 누적 점수(인덱스 = 도달 단계 0..n) */
const CUM: Readonly<Record<CodexCat, readonly number[]>> = (() => {
  const o = {} as Record<CodexCat, number[]>;
  for (const cat of Object.keys(CODEX_STEP_SCORES) as CodexCat[]) {
    const a = [0];
    for (const s of CODEX_STEP_SCORES[cat]) a.push(a[a.length - 1] + s);
    o[cat] = a;
  }
  return o;
})();

/** 칸 하나가 줄 수 있는 최대 점수 */
export function cellMaxScore(cat: CodexCat): number { const a = CUM[cat]; return a[a.length - 1]; }

/** 값 → 도달 단계(0 = 미등록). NaN·음수·Infinity는 0/최대로 안전하게 */
export function cellStage(cat: CodexCat, value: number): 0 | 1 | 2 | 3 | 4 {
  const st = CODEX_CELL_STEPS[cat];
  let n = 0;
  if (value >= 0) for (let i = 0; i < st.length; i++) if (value >= st[i]) n = i + 1; // NaN은 비교가 거짓이라 0
  return n as 0 | 1 | 2 | 3 | 4;
}
/** 값 → 누적 점수 */
export function cellScore(cat: CodexCat, value: number): number { return CUM[cat][cellStage(cat, value)]; }
